module.exports = __webpack_public_path__ + "static/600x550-orlencharge-termin3-en-c5f7e2dddc2d1ac2e41a465e2cb5a266.jpg";